<div class="ruckit-customer-reference-cell">
  <customer-reference-selector
    #customerReferences
    (referenceSelected)="onReferenceClicked($event)"
    (onClose)="onReferenceClosed()"
  ></customer-reference-selector>
</div>
